__webpack_require__.p = "/dev/617-svginjector-demo-sur-un-svg-simple/";